import React from "react"

const CrossIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 31 31" fill="currentColor">
    <path d="M 31 1.4 L 29.6 0 L 15.5 14.1 L 1.4 0 L 0 1.4 l 14.1 14.1 L 0 29.6 L 1.4 31 l 14.1 -14.1 L 29.6 31 l 1.4 -1.4 l -14.1 -14.1 Z" />
  </svg>
)


export default CrossIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/CrossIcon.jsx